document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
        this.openFromHeader = (event) => {
          if (!document.getElementById('right-drawer-slot')) return;
          event.preventDefault();
          this.headerTrigger = document.querySelector('[data-cart-drawer-trigger]');
          Alpine.store('modals').open('cart');
        };
        this.restoreHeaderFocus = () => {
          this.headerTrigger?.focus();
          this.headerTrigger = null;
        };
        document.addEventListener('mudad:cart:open', this.openFromHeader);
        document.addEventListener('cart-is-closed', this.restoreHeaderFocus);
      },
      destroy() {
        document.removeEventListener('mudad:cart:open', this.openFromHeader);
        document.removeEventListener('cart-is-closed', this.restoreHeaderFocus);
      },
    };
  });
});
